import { useEffect } from 'react';

import { useStoreProject } from './hooks/use-project';
import { useActions } from './hooks/use-actions';
import { useApi } from './hooks/use-api';

/* store data to local storage */

export const useLocalstore = () => {
  const { storeProject } = useStoreProject();
  const { storeActions } = useActions();
  const { storeApi } = useApi();

  useEffect(() => {
    const cb = () => {
      storeApi();
      storeProject();
      storeActions();
    };
    window.addEventListener('beforeunload', cb);
    return () => window.removeEventListener('beforeunload', cb);
  }, []);
};
